"use strict";

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
}); //================================================================ 

/** @module std.base */
//================================================================

var MultiSet_1 = require("./MultiSet");

var _ITreeContainer_1 = require("./_ITreeContainer");

var Pair_1 = require("../../utility/Pair");

var MultiTreeSet =
/** @class */
function (_super) {
  __extends(MultiTreeSet, _super);

  function MultiTreeSet() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /* ---------------------------------------------------------
      ACCESSORS
  --------------------------------------------------------- */

  /**
   * @inheritDoc
   */


  MultiTreeSet.prototype.find = function (key) {
    var it = this.lower_bound(key);
    if (!it.equals(this.end()) && this._Key_eq(key, it.value)) return it;else return this.end();
  };
  /**
   * @inheritDoc
   */


  MultiTreeSet.prototype.count = function (key) {
    var it = this.find(key);
    var ret = 0;

    for (; !it.equals(this.end()) && this._Key_eq(it.value, key); it = it.next()) {
      ++ret;
    }

    return ret;
  };
  /**
   * @inheritDoc
   */


  MultiTreeSet.prototype.equal_range = function (key) {
    return new Pair_1.Pair(this.lower_bound(key), this.upper_bound(key));
  };
  /**
   * @inheritDoc
   */


  MultiTreeSet.prototype.value_comp = function () {
    return this.key_comp();
  };
  /**
   * @hidden
   */


  MultiTreeSet.prototype._Key_eq = function (x, y) {
    return !this.key_comp()(x, y) && !this.key_comp()(y, x);
  };
  /* ---------------------------------------------------------
      INSERT
  --------------------------------------------------------- */

  /**
   * @hidden
   */


  MultiTreeSet.prototype._Insert_by_key = function (key) {
    // FIND POSITION TO INSERT
    var it = this.upper_bound(key); // ITERATOR TO RETURN

    it = this.data_.insert(it, key);

    this._Handle_insert(it, it.next());

    return it;
  };
  /**
   * @hidden
   */


  MultiTreeSet.prototype._Insert_by_hint = function (hint, key) {
    var validate = _ITreeContainer_1._Emplacable(this, hint, key);

    if (validate) {
      var it = this.data_.insert(hint, key);

      this._Handle_insert(it, it.next());

      return it;
    } else return this._Insert_by_key(key);
  };
  /**
   * @hidden
   */


  MultiTreeSet.prototype._Insert_by_range = function (first, last) {
    for (var it = first; !it.equals(last); it = it.next()) {
      this._Insert_by_key(it.value);
    }
  };

  return MultiTreeSet;
}(MultiSet_1.MultiSet);

exports.MultiTreeSet = MultiTreeSet;